import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

export default function RefundPage() {
  return (
    <LegalDocumentPage
      slug="refund"
      fallbackTitle="Возврат и отмена"
      fallbackFile="/docs/refund.html"
    />
  );
}
